<template>
  <div id="container">
    <div class="edit-or-add-content">
      <!------------ 合同总览 ------------>
      <contract-pandect ref="contractPandectRefs" :contractOverview="contractOverview"></contract-pandect>
      <!------------ 客户信息 ------------>
      <customer-module
        :customer-data="customerAccountCreditVo"
        :isShowTransfer="true"
        :isShowChange="false"
      ></customer-module>
      <!------------ 物流信息 ------------>
      <logistics-information
        :orderContractLogistic="orderContractLogistic"
        :signState="contractOverview.signState"
        ref="logisticsRefs"
      ></logistics-information>

      <!------------ 收货信息 ------------>
      <goods-receiving-information
        :cusId="contractOverview.cusId"
        :contractOverview="contractOverview"
        :orderContractReceive="orderContractReceive"
        ref="goodsReceivingInformationRefs"
      ></goods-receiving-information>
      <!------------ 账期设置 ------------>
      <bill-set
        ref="billSetRefs"
        :payTypel="payType"
        :orderContractAppointment="orderContractAppointment"
        :orderContractOtherPayment="orderContractOtherPayment"
        :contractOverview="contractOverview"
        @getProportion="getProportion"
        @onAlterProduct="onAlterProduct"
      ></bill-set>
      <!------------ 交货设置 ------------>
      <delivery-set :contractOverview="contractOverview" ref="deliverySetRefs"></delivery-set>
      <!------------ 产品清单 ------------>
      <product-list
        :contractOverview="contractOverview"
        :isSetFutures="isSetFutures"
        :isOpenExtime="isOpenExtime"
        :productList="productList"
        :futuresPaymentTable="futuresPaymentList"
        :productListTotal="productListTotal"
        :goodAmountPer="goodAmountPer"
        :goodAmount="goodAmount"
        @getParentDataMax="getParentDataMax"
        ref="productListRefs"
      ></product-list>
      <!------------ 合同盖章上传 ------------>
      <sealed-contract-upload ref="sealedContractUploadRefs" v-show="isShowContractUpload"></sealed-contract-upload>
      <!------------ 工单日志 ------------>
      <operation-log-and-flow :flowLabel="flowLabel" :id="contractOverview.id"></operation-log-and-flow>
      <!------------ 提交审批 / 合同作废 ------------>
      <open-or-close
        @onUpdataState="onSubmitApprover"
        :content="content"
        :title="title"
        ref="openOrCloseRefs"
      ></open-or-close>
      <!------------ 重新提交审核 / 审核不通过确认 ------------>
      <reject-dialog
        @onRejectDialog="onRejectDialog"
        :content="content"
        :title="title"
        ref="rejectDialogRefs"
      ></reject-dialog>
    </div>
    <!------------ 合同审批 ------------>
    <div class="edit-fixed-bottom" v-if="contractOverview.signState!==6">
      <el-row v-show="contractOverview.signState===3">
        <el-button @click="onContractPreview" type="primary">合同预览</el-button>
        <el-button @click="onContractDownload">合同下载</el-button>
        <el-button @click="onContractUpload">合同盖章上传</el-button>
        <el-button @click="onApplyApproContractAgain" type="primary">重新提交审核</el-button>
        <el-button @click="onCancellation">合同作废</el-button>
      </el-row>
      <el-row v-show="contractOverview.signState===1">
        <el-button @click="onApplyApproContract" type="primary">申请审批合同</el-button>
        <el-button @click="onCancellation">合同作废</el-button>
      </el-row>
      <div class="config-instruction">
        <i class="el-icon-warning-outline"></i>
        <span v-show="contractOverview.signState===1">生成说明：合同通过审批后，允许重新申请审批</span>
        <span
          v-show="contractOverview.signState===2 || contractOverview.signState===8"
        >已提交合同审批，请等待审核</span>
        <span v-show="contractOverview.signState===7">审核不通过原因:{{contractOverview.exPlain}}</span>
        <span v-show="contractOverview.signState===9">驳回原因:{{contractOverview.exPlain}}</span>
        <span v-show="contractOverview.signState===3">
          合同盖章上传后，需与原合同内容做对比。重新提交审批后，合同状态更改为待审核，需重新发起审批流程。
          <br />合同作废后释放被占用的信用额度，且该合同不可再提交审核
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadDown } from '@/util/tool'
import contractPandect from './contractPandect' // 合同总览
import rejectDialog from '../../dialog/rejectDialog' // 驳回弹窗
import customerModule from '@/components/checkLayout/module/customerModule'
import logisticsInformation from '../quiry/logisticsInformation' // 物流信息
import goodsReceivingInformation from './goodsReceivingInformation' // 收货信息
import billSet from './billSet' // 账期设置
import deliverySet from './deliverySet' // 交货设置
import productList from './productList' // 产品清单
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import OpenOrClose from '@/components/OpenOrClose/index' // 提交审批,合同作废,合同审核不通过
import sealedContractUpload from './sealedContractUpload' // 合同盖章上传
import {
  queryUploadOcbId,
  orderContractBaseAdd,
  orderContractBaseQueryByOcbId,
  updateStateByOcbId
} from '@/api/sell/sellManage'
export default {
  components: {
    'customer-module': customerModule, // 客户数据
    'contract-pandect': contractPandect, // 合同预览
    'logistics-information': logisticsInformation, // 物流信息
    'goods-receiving-information': goodsReceivingInformation, // 收货信息
    'bill-set': billSet, // 账单设置
    'delivery-set': deliverySet, // 交货设置
    'product-list': productList, // 产品清单
    'operation-log-and-flow': operationLogAndFlow, // 工单日志
    'open-or-close': OpenOrClose, // 审批,合同作废,合同审核不通过
    'reject-dialog': rejectDialog, // 驳回弹窗
    'sealed-contract-upload': sealedContractUpload // 合同盖章上传
  },
  data() {
    return {
      title: '',
      content: '',
      isShowContractUpload: false,
      isSetFutures: false, // 是否设置多期期货
      isOpenExtime: 0, // 是否开启提醒 0 不开启 1开启
      flowLabel: '签署流程',
      productList: [], // 产品清单信息(除了期货期款)
      futuresPaymentList: [], // 期货期款数据
      contractOverview: {}, // 合同总览
      productListTotal: [], // 产品信息总计
      customerAccountCreditVo: {}, // 客户信息
      orderContractLogistic: {}, // 物流信息
      orderContractReceive: {}, // 收货信息
      orderContractAppointment: {}, // 约定账期
      orderContractOtherPayment: {}, // 付款类型除了约定账期的所有方式
      payType: 0, // 付款类型:1是约定账期,2是全款发货,3是先货后款,4期货期款
      goodAmountPer: 0, // 货款比例
      goodAmount: 0,
      allocationFalse: false, // 判断是否存在待分配产品
      orderShipmentContentVoList: [] // 期货期款列表
    }
  },
  mounted() {
    this.getcContractEdit()
    if (this.$route.query.stamp) {
      this.onContractUpload()
    }
  },
  methods: {
    // 根据合同id查看详情
    getcContractEdit() {
      orderContractBaseQueryByOcbId(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          if (res.data.obj.signState === 4 || res.data.obj.signState === 5) {
            this.$router.push({
              name: 'contractEdit',
              query: { id: this.$route.query.id, cusId: res.data.obj.cusId }
            })
          }
          if (res.data.obj.signState === 7 || res.data.obj.signState === 9) {
            this.title =
              res.data.obj.signState === 7 ? '合同审核不通过' : '审核驳回'
            this.content = '拒绝原因：' + res.data.obj.exPlain
            this.$refs.rejectDialogRefs.onInitial()
          }
          if (res.data.obj.payType === 4) {
            this.isSetFutures = true
          }
          res.data.obj.cusName = res.data.obj.customerAccountCreditVo.cusName // 客户名称
          this.isOpenExtime = res.data.obj.isOpenExtime // 是否开启提醒
          this.contractOverview = res.data.obj // 生成合同返回的所有数据
          // 由于生成合同返回的数据不是分块返回,所以需要前端自己拼成块状,最后申请审批合同需要把所有对象拼起来传给后端
          this.customerAccountCreditVo = res.data.obj.customerAccountCreditVo // 客户信息
          this.productList = res.data.obj.orderContractContentList // 除了期货期款产品清单信息
          this.futuresPaymentList = res.data.obj.orderShipmentContentVoList // 期货期款产品列表
          this.productListTotal = []
          const productTotalParams = {
            // 产品总计
            contractKind: res.data.obj.contractKind,
            contractTotal: res.data.obj.contractTotal,
            contractCost: res.data.obj.contractCost,
            contractRate: res.data.obj.contractRate
          }
          this.productListTotal.push(productTotalParams)
          this.orderContractLogistic = res.data.obj.orderContractLogistic // 物流信息
          this.orderContractReceive = res.data.obj.orderContractReceive || {} // 收货信息
          this.orderContractAppointment = res.data.obj.orderContractAppointment // 约定账期
          this.orderContractOtherPayment =
            res.data.obj.orderContractOtherPayment // 除了约定账期的多有付款方式数据
          this.payType = res.data.obj.payType ? res.data.obj.payType : 1
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getParentDataMax(list, show) {
      this.orderShipmentContentVoList = list
      this.allocationFalse = show
    },
    // 申请审批合同
    onApplyApproContract() {
      if (this.payType === 1) {
        // 判断 约定账期
        if (
          !this.$refs.billSetRefs.orderContractAppointmentParams.appointType ||
          !this.$refs.billSetRefs.orderContractAppointmentParams.appointValue
        ) {
          this.$message.error('申请失败，请设置约定条件！')
          return
        }
      } else {
        if (this.$refs.billSetRefs.params.isAdvance) {
          if (
            !this.$refs.billSetRefs.params.advanceAmount ||
            !this.$refs.billSetRefs.params.advanceAmountProportion
          ) {
            this.$message.error('申请失败，请设置预付款金额和预付款百分比！')
            return
          }
        }
        if (this.$refs.billSetRefs.params.isGuarantee) {
          if (
            !this.$refs.billSetRefs.params.guaranteeAmount ||
            !this.$refs.billSetRefs.params.guaranteeAmountProportion
          ) {
            this.$message.error('申请失败，请设置质保金金额和质保金百分比！')
            return
          }
          if (!this.$refs.billSetRefs.params.guaranteeTime) {
            this.$message.error('申请失败，请设置质保期限！')
            return
          }
        }
      }
      let cbExtimeValueFalse = false
      if (this.payType === 4) {
        this.$refs.productListRefs.onEventBus()
        if (this.allocationFalse) {
          this.$message.error('申请失败，存在待分配产品未分配！')
          return
        }
        if (this.orderShipmentContentVoList.length < 2) {
          this.$message.error('申请失败，货期需最少设置两期！')
          return
        }
        let shipTotalFalse = false
        let shipPayDateFalse = false
        let equalData = false
        let lessData = false
        this.orderShipmentContentVoList.forEach((ele, i) => {
          if (i < this.orderShipmentContentVoList.length - 1) {
            if (!ele.shipTotal) {
              shipTotalFalse = true
            }
          }
          if (ele.shipPayDate === undefined) {
            shipPayDateFalse = true
          }
          if (i < this.orderShipmentContentVoList.length - 1) {
            if (
              ele.shipPayDate ===
              this.orderShipmentContentVoList[i + 1].shipPayDate
            ) {
              equalData = true
            }
            if (
              ele.shipPayDate >
              this.orderShipmentContentVoList[i + 1].shipPayDate
            ) {
              lessData = true
            }
          }
          ele.orderShipmentQueryVoList.forEach((item) => {
            item.ccId = item.id
            if (!item.cbExtimeValue) {
              cbExtimeValueFalse = true
            }
          })
        })
        if (shipTotalFalse) {
          this.$message.error('申请失败，存在本期货款金额未填写')
          return
        }
        if (shipPayDateFalse) {
          this.$message.error('申请失败，请设置预计付款时间！')
          return
        }
        if (equalData) {
          this.$message.error('申请失败，预计付款时间不可相同！')
          return
        }
        if (lessData) {
          this.$message.error('申请失败，预计付款时间不可小于上一期！')
          return
        }
      } else {
        const list = this.$refs.productListRefs.list
        list.forEach((ele) => {
          if (!ele.cbExtimeValue) {
            cbExtimeValueFalse = true
          }
        })
      }
      if (cbExtimeValueFalse) {
        this.$message.error('申请失败，请设置货期！')
        return
      }
      // 判断交货方式
      if (this.$refs.deliverySetRefs.queryParams.deliverySetting === 2) {
        if (!this.$refs.deliverySetRefs.queryParams.deliveryDate) {
          this.$message.error('申请失败，请设置约定发货日期！')
          return
        }
      }
      // 判断收货人
      if (!this.$refs.goodsReceivingInformationRefs.queryParams.receiveName) {
        this.$message.error('请选择收货人')
        return
      }
      this.title = '提交审批'
      this.content = '请确认是否提交审批？'
      this.$refs.openOrCloseRefs.onInitial()
    },
    // 重新提交审核
    onApplyApproContractAgain() {
      this.title = '确认重新提交审批'
      this.content = '确认后合同状态更改为待审核，需重新发起审批流程'
      this.$refs.openOrCloseRefs.onInitial()
    },
    onContractPreview() {
      // 合同预览
      this.$router.push({
        name: 'contractPreview',
        query: {
          id: this.$route.query.id,
          pcbNumber: this.contractOverview.contractCode
        }
      })
    },
    onContractDownload() {
      // 合同下载
      queryUploadOcbId(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          uploadDown(
            this.$store.state.https + res.data.obj.fileUrl,
            this.contractOverview.contractCode
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 合同作废
    onCancellation() {
      this.title = '合同作废'
      this.content = '请确认是否合同作废，一旦作废无法恢复！'
      this.$refs.openOrCloseRefs.onInitial()
    },
    // 合同盖章上传
    onContractUpload() {
      this.isShowContractUpload = true
      this.$refs.sealedContractUploadRefs.getList(this.$route.query.id, 1)
      setTimeout(() => {
        const num = this.$refs.sealedContractUploadRefs.$el.offsetTop
        document.querySelector('.el-main').scrollTop = num
      }, 100)
    },
    // 获取 货款比例
    getProportion(val, item) {
      this.goodAmountPer = val
      this.goodAmount = item
    },
    onRejectDialog() {
      // 审核不通过改变状态
      let num = 0
      if (this.contractOverview.signState === 9) {
        num = 3
      } else {
        num = 1
      }
      updateStateByOcbId(this.$route.query.id, num)
        .then((res) => {
          if (res.data.code === 200) {
            this.getcContractEdit()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 确认提交审批or合同作废
    onSubmitApprover() {
      if (this.title === '提交审批') {
        var params = {
          ...this.$refs.contractPandectRefs.queryParams,
          ...this.$refs.deliverySetRefs.queryParams,
          isOpenExtime: Number(this.$refs.productListRefs.checked),
          orderContractContentList: this.$refs.productListRefs.list,
          orderContractLogistic: this.$refs.logisticsRefs.queryParams,
          orderContractReceive: this.$refs.goodsReceivingInformationRefs
            .queryParams,
          payType: this.payType,
          replenMark: this.$refs.billSetRefs.params.replenMark
        }
        if (this.$refs.billSetRefs.payType === 1) {
          params.orderContractAppointment = this.$refs.billSetRefs.orderContractAppointmentParams
        } else {
          const obj = this.$refs.billSetRefs.params
          obj.guaranteeAmountProportion = obj.guaranteeAmountProportion
            ? Number(obj.guaranteeAmountProportion) / 100
            : null
          obj.advanceAmountProportion = obj.advanceAmountProportion
            ? Number(obj.advanceAmountProportion) / 100
            : null
          obj.goodAmountProportion = +(this.goodAmountPer) / 100
          params.orderContractOtherPayment = obj
          if (this.$refs.billSetRefs.payType === 4) {
            params.orderShipmentContentVoList = this.orderShipmentContentVoList
          }
        }
        orderContractBaseAdd(params).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已提交合同审批，请等待审核！')
            this.$router.push({
              path: '/sell/personageManagement/contractList'
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (
        this.title === '合同作废' ||
        this.title === '确认重新提交审批'
      ) {
        const num = this.title === '合同作废' ? 6 : 1
        updateStateByOcbId(this.$route.query.id, num).then((res) => {
          if (res.data.code === 200) {
            if (this.title === '确认重新提交审批') {
              this.$message.success('已重新提交审批,请重新发起审批流程')
              this.getcContractEdit()
            } else {
              this.$router.push({ name: 'contractList' })
              this.$message.success('合同已作废，可在合同列表中查看')
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    // 账期设置选择期货期款更改产品清单状态
    onAlterProduct(val) {
      this.payType = val
      if (val === 4) {
        this.isSetFutures = true
      } else {
        this.isSetFutures = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#container {
  height: 100%;
  .config-instruction {
    padding: 10px 0px 10px 0px;
  }
}
</style>
